import { Directive, ElementRef, Input, OnDestroy } from '@angular/core';
import { ValidationErrors } from 'ngrx-forms/src/state';
import tippy, { Instance as TippyInstance } from 'tippy.js';

@Directive({
  selector: '[mdFormError]',
})
export class FormErrorDirective implements OnDestroy {
  errorText = '';
  tippy: TippyInstance;
  hover = false;
  focused = false;

  @Input() set mdFormError(errors: ValidationErrors | undefined | null) {
    this.errorText = this.parseErrors(errors);
    this.updateTooltip();
  }

  @Input('mdFormErrorShowAlways')
  showAlways = false;

  constructor(private elementRef: ElementRef<HTMLElement>) {
    this.tippy = tippy(elementRef.nativeElement, {
      trigger: 'manual',
      theme: 'light-border',
      hideOnClick: false,
      allowHTML: true,
    });

    elementRef.nativeElement.addEventListener('mouseenter', () => {
      this.hover = true;
      this.updateTooltip();
    });
    elementRef.nativeElement.addEventListener('focus', () => {
      this.focused = true;
      this.updateTooltip();
    });

    elementRef.nativeElement.addEventListener('mouseleave', () => {
      this.hover = false;
      this.updateTooltip();
    });
    elementRef.nativeElement.addEventListener('blur', () => {
      this.focused = false;
      this.updateTooltip();
    });
  }

  updateTooltip() {
    if (this.errorText) {
      if (this.focused || this.hover || this.showAlways) {
        const html = `
        <div style='display: flex;'>
          <i class="material-icons text-danger" style='margin-right: 5px; font-size: 18px;'>error</i>
          <div>${this.errorText}</div>
        </div>
        `;
        this.tippy.setContent(html);
        this.tippy.show();
      } else {
        this.tippy.hide();
      }
    } else {
      this.tippy.hide();
    }
  }

  parseErrors(errors?: ValidationErrors | undefined | null): string {
    if (!errors) {
      return '';
    }

    const errorsAsStrings: string[] = Object.entries(errors)
      .map(([key, value]) => {
        if (typeof value === 'string' && value) {
          return value;
        } else if (key === 'required') {
          return 'This field is required';
        } else if (key === 'invalid') {
          return 'Invalid value';
        }
        return '';
      })
      .filter(error => error !== '');

    if (errorsAsStrings.length) {
      return errorsAsStrings[0];
    } else {
      return '';
    }
  }

  ngOnDestroy(): void {
    this.tippy.destroy();
  }
}
